import React from 'react';
import styled from 'styled-components';
import invalidDrive from '../../images/invalid-drive.svg';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img {
    width: 160px;
    margin-bottom: 16px;
  }

  p {
    color: ${props => props.theme.textColor};
    margin: 0;
    font-size: 16px;
    text-align: center;
  }
`;

const InvalidDrive = () => (
  <Wrapper>
    <img src={invalidDrive} alt="Drive doesn't exist" />
    <p>Invalid drive. Enter correct url</p>
  </Wrapper>
);

export default InvalidDrive;



// WEBPACK FOOTER //
// ./src/views/InvalidDrive/InvalidDrive.js